export const getFormattedNumericDate = (date) => new Date(date).toLocaleDateString('en-US');
